import React from 'react';
import { container } from 'tsyringe';
import { LaporanKepesantrenanPresenter } from '../../../../../../data/presenters/LaporanKepesantrenanPresenter';
import { LaporanKepesantrenan } from '../../../../../../entities/LaporanKepesantrenan';
import { toast } from 'react-toastify';

interface IState {
  isLoading: boolean;
  isExporting: boolean;
  page: number;
  rows: number;
  listData: LaporanKepesantrenan[];
  totalData: number;
  namaPesantren: string;
  peran: string;
}

interface InitialState {
  state: IState;
  fetchData: Function;
  exportData: Function;
  setPage: Function;
  setPageRow: Function;
  setNamaPesantren: Function;
  setPeran: Function;
}

const initialState: InitialState = {
  state: {
    isLoading: false,
    isExporting: false,
    page: 1,
    rows: 15,
    listData: [],
    totalData: 0,
    namaPesantren: '',
    peran: '',
  },
  fetchData: () => {},
  exportData: () => {},
  setPage: () => {},
  setPageRow: () => {},
  setNamaPesantren: () => {},
  setPeran: () => {},
};

const Context = React.createContext<InitialState>(initialState);
const { Provider: LaporanKepesantrenanController } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({ ...initialState.state });

  const setLoading = (value: boolean) =>
    setState((prev) => ({ ...prev, isLoading: value }));

  const setExporting = (value: boolean) =>
    setState((prev) => ({ ...prev, isExporting: value }));

  const setPage = (value: number) =>
    setState((prev) => ({ ...prev, page: value }));

  const setPageRow = (value: number) =>
    setState((prev) => ({ ...prev, rows: value }));

  const setNamaPesantren = (value: string) =>
    setState((prev) => ({ ...prev, namaPesantren: value }));

  const setPeran = (value: string) =>
    setState((prev) => ({ ...prev, peran: value }));

  const fetchData = async (
    page: number,
    rows: number,
    namaPesantren: string,
    peran: string,
  ) => {
    setLoading(true);
    try {
      const presenter = container.resolve(LaporanKepesantrenanPresenter);
      const result = await presenter.getList(page, rows, namaPesantren, peran);
      setState((prev) => ({
        ...prev,
        listData: result.data,
        totalData: result.total,
        isLoading: false,
      }));
    } catch (error: any) {
      console.log('error fetch laporan kepesantrenan :', error);
      toast.error('Gagal memuat data laporan kepesantrenan', {
        style: { boxShadow: '0px 1px 6px #F86E70' },
      });
      setLoading(false);
    }
  };

  const exportData = async (namaPesantren: string, peran: string) => {
    setExporting(true);
    try {
      const presenter = container.resolve(LaporanKepesantrenanPresenter);
      const response = await presenter.exportExcel(namaPesantren, peran);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Laporan-Data-Kepesantrenan.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      console.log('error export laporan kepesantrenan :', error);
      toast.error('Gagal export data', {
        style: { boxShadow: '0px 1px 6px #F86E70' },
      });
    } finally {
      setExporting(false);
    }
  };

  return (
    <LaporanKepesantrenanController
      value={{
        state,
        fetchData,
        exportData,
        setPage,
        setPageRow,
        setNamaPesantren,
        setPeran,
      }}
    >
      {children}
    </LaporanKepesantrenanController>
  );
};

export const useLaporanKepesantrenan = () => React.useContext(Context);
// eslint-disable-next-line
export default {
  useLaporanKepesantrenan,
  Provider,
};
